const slugify = (value = '') =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const getOtherDeductionEntries = (record = {}) => {
  const rawEntries =
    record.other_deduction_breakdown ||
    record.otherDeductionBreakdown ||
    [];

  return Array.isArray(rawEntries)
    ? rawEntries
        .map((item) => ({
          deductionType: item.deduction_type || item.deductionType || '',
          amount: Number(item.amount || 0),
        }))
        .filter((item) => item.deductionType)
    : [];
};

export const buildOtherDeductionColumns = (records = []) => {
  const seen = new Map();

  records.forEach((record) => {
    getOtherDeductionEntries(record).forEach((item) => {
      const accessorKey = `other_deduction__${slugify(item.deductionType)}`;
      if (!accessorKey || seen.has(accessorKey)) {
        return;
      }

      seen.set(accessorKey, {
        accessorKey,
        label: item.deductionType,
      });
    });
  });

  return Array.from(seen.values()).sort((left, right) => left.label.localeCompare(right.label));
};

export const flattenOtherDeductionBreakdown = (record = {}, columns = []) => {
  const entryMap = new Map(
    getOtherDeductionEntries(record).map((item) => [item.deductionType.toLowerCase(), item.amount])
  );

  return columns.reduce((accumulator, column) => {
    accumulator[column.accessorKey] = Number(entryMap.get(column.label.toLowerCase()) || 0);
    return accumulator;
  }, {});
};

export const getOtherDeductionBreakdownTotal = (record = {}) =>
  getOtherDeductionEntries(record).reduce((sum, item) => sum + (Number(item.amount) || 0), 0);

export const getBillingOtherDeductionBreakdown = (billingDetails = {}) =>
  getOtherDeductionEntries({
    other_deduction_breakdown:
      billingDetails.other_deduction_breakdown || billingDetails.otherDeductionBreakdown || [],
  });

export const getBillingManualOtherDeductions = (billingDetails = {}) => {
  const rawValue =
    billingDetails.other_deductions ??
    billingDetails.otherDeductions ??
    billingDetails.others ??
    0;

  if (Array.isArray(rawValue)) {
    return rawValue.reduce((sum, item) => {
      if (item && typeof item === 'object') {
        return sum + (Number(item.amount || 0) || 0);
      }

      return sum + (Number(item || 0) || 0);
    }, 0);
  }

  if (rawValue && typeof rawValue === 'object') {
    return Number(rawValue.amount || 0) || 0;
  }

  return Number(rawValue || 0) || 0;
};

export const getBillingOtherDeductionBreakdownTotal = (billingDetails = {}) => {
  const explicitTotal = Number(
    billingDetails.other_deduction_breakdown_total ?? billingDetails.otherDeductionBreakdownTotal
  );

  if (Number.isFinite(explicitTotal) && explicitTotal > 0) {
    return explicitTotal;
  }

  return getBillingOtherDeductionBreakdown(billingDetails).reduce(
    (sum, item) => sum + (Number(item.amount) || 0),
    0
  );
};
